<div id="print-order-toggle-btn" fxLayout="row" fxFlex="center center">
  <div
    class="btn-one-sided pbt-btn"
    matRipple
    fxFlex="50"
    [class.activated]="default === 'oneSide'"
    (click)="select('oneSide')"
  >
    <div class="title">یک رو</div>
  </div>
  <div
    class="btn-two-sided pbt-btn"
    matRipple
    fxFlex="50"
    [class.activated]="default === 'twoSide'"
    (click)="this.select('twoSide')"
  >
    <div class="title">دو رو</div>
  </div>
</div>
